import React from 'react';

/**
 * FAQ 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const FAQProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'title',
        label: 'FAQ 제목',
        control: 'TextField',
        defaultValue: '자주하는질문'
      },
      {
        name: 'style.width',
        label: '너비',
        control: 'TextField',
        defaultValue: '100%'
      },
      {
        name: 'style.padding',
        label: '여백',
        control: 'TextField',
        defaultValue: '0px'
      }
    ]
  },
  {
    group: '제목 스타일',
    properties: [
      {
        name: 'titleStyle.fontSize',
        label: '글자 크기',
        control: 'TextField',
        defaultValue: '24px'
      },
      {
        name: 'titleStyle.color',
        label: '글자 색상',
        control: 'ColorPicker',
        defaultValue: '#333'
      },
      {
        name: 'titleStyle.fontWeight',
        label: '글자 두께',
        control: 'Select',
        options: [
          { value: 'normal', label: '보통' },
          { value: 'bold', label: '굵게' },
          { value: '300', label: '얇게' },
          { value: '500', label: '중간' },
          { value: '700', label: '매우 굵게' }
        ],
        defaultValue: 'bold'
      },
      {
        name: 'titleStyle.marginBottom',
        label: '하단 여백',
        control: 'TextField',
        defaultValue: '20px'
      },
      {
        name: 'titleStyle.textAlign',
        label: '정렬',
        control: 'Select',
        options: [
          { value: 'left', label: '왼쪽' },
          { value: 'center', label: '가운데' },
          { value: 'right', label: '오른쪽' }
        ],
        defaultValue: 'left'
      }
    ]
  },
  {
    group: 'FAQ 항목 스타일',
    properties: [
      {
        name: 'style.borderRadius',
        label: '모서리 둥글기',
        control: 'TextField',
        defaultValue: '8px'
      },
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: '0 1px 3px rgba(0, 0, 0, 0.1)'
      }
    ]
  },
  {
    group: 'FAQ 항목 관리',
    properties: [
      {
        name: 'faqItems',
        label: 'FAQ 항목',
        control: 'ItemList',
        itemFields: [
          { name: 'question', label: '질문', control: 'TextField' },
          { name: 'answer', label: '답변', control: 'TextArea' }
        ],
        defaultValue: []
      }
    ]
  }
];

export default FAQProperties; 